// SELF COUNT API
import Request from '../base'
export default {
  orggroup (options) {
    return Request.post('/ebercount/countapi/revenue/count/charge', options)
  }
}
